import * as R from 'ramda';
import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';

import {
  fetchOrders,
  fetchBatches,
  fetchUsers,
  fetchOrdersFilterOptions,
} from '../../utils/api/client';
import { getPosApiUrl, getAccessToken } from '../../utils/state';
import {
  FETCH_ORDERS_REQUEST,
  FETCH_USERS_REQUEST,
  FETCH_BATCHES_REQUEST,
  fetchOrdersSuccess,
  fetchOrdersError,
  fetchUsersSuccess,
  fetchBatchesSuccess,
  ordersIndexAlertBarAction,
} from './OrdersIndex.state';
import { getFiltersFromFields } from '../../utils/helpers';
import { caughtError } from '../../utils/api/errorHandler';
import {
  FETCH_ORDERS_FILTER_OPTIONS,
  fetchOrdersFilterOptionsSuccess,
  fetchOrdersFilterOptionsError,
} from '../../state/shared';

const caughtOrdersIndexErrorCallback = (state) =>
  caughtError(ordersIndexAlertBarAction, 'Orders Index Error:', state);

const getOrdersIndexFiltersParam = (state) => {
  const filterFields = R.pathOr(
    [],
    ['ordersIndex', 'forms', 'ordersIndexFiltersForm'],
    state,
  );

  return getFiltersFromFields(filterFields);
};

const fetchOrdersParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
  pageIndex: state.ordersIndex.currentPage,
  pageSize: state.ordersIndex.pageSize,
  filters: getOrdersIndexFiltersParam(state),
});

export const fetchOrdersEpic = (action$, state$) =>
  action$.ofType(FETCH_ORDERS_REQUEST).pipe(
    RxOp.switchMap(() =>
      Rx.from(fetchOrders(fetchOrdersParams(state$.value))).pipe(
        RxOp.flatMap((response) =>
          Rx.of(
            fetchOrdersSuccess({
              data: response.data,
              pageCount: response.data.pagesTotal,
              totalOrders: response.data.recordsTotal,
            }),
          ),
        ),
        RxOp.catchError((err) =>
          caughtOrdersIndexErrorCallback(state$.value)(
            err,
            fetchOrdersError(err.message),
          ),
        ),
      ),
    ),
  );

const fetchBatchesParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
});

export const fetchBatchesEpic = (action$, state$) =>
  action$.ofType(FETCH_BATCHES_REQUEST).pipe(
    RxOp.flatMap(() =>
      Rx.from(fetchBatches(fetchBatchesParams(state$.value))).pipe(
        RxOp.flatMap((response) => Rx.of(fetchBatchesSuccess(response))),
        RxOp.catchError((err) =>
          caughtOrdersIndexErrorCallback(state$.value)(err),
        ),
      ),
    ),
  );

const fetchUsersParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
});
export const fetchUsersEpic = (action$, state$) =>
  action$.ofType(FETCH_USERS_REQUEST).pipe(
    RxOp.flatMap(() =>
      Rx.from(fetchUsers(fetchUsersParams(state$.value))).pipe(
        RxOp.flatMap((response) => Rx.of(fetchUsersSuccess(response))),
        RxOp.catchError((err) =>
          caughtOrdersIndexErrorCallback(state$.value)(err),
        ),
      ),
    ),
  );

const fetchOrdersFilterOptionsParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
});

export const fetchOrdersFilterOptionsEpic = (action$, state$) =>
  action$.ofType(FETCH_ORDERS_FILTER_OPTIONS).pipe(
    RxOp.flatMap(() =>
      Rx.from(
        fetchOrdersFilterOptions(fetchOrdersFilterOptionsParams(state$.value)),
      ).pipe(
        RxOp.flatMap((response) =>
          Rx.of(fetchOrdersFilterOptionsSuccess(response)),
        ),
        RxOp.catchError((err) =>
          caughtOrdersIndexErrorCallback(state$.value)(
            err,
            fetchOrdersFilterOptionsError(err.message),
          ),
        ),
      ),
    ),
  );
